import { Branch } from "@/app/branchs/branchs.type";
import DescriptionHeadings from "@/shared/components/atoms/DescriptionHeadings";
import { t } from "i18next";
import BenefitsChart from "../Charts/BenefitsChart";
import BenefitsDaysChart from "../Charts/BenefitsDaysChart";

export type BenefitsProps = {
  branches: Branch[];
};

const BenefitsComponent: React.FC<BenefitsProps> = ({ branches }) => {
  return (
    <>
      <div className="p-4">
        <DescriptionHeadings
          title={t("user.views.main_benefits")}
          description={t("user.views.main_message_benefits")}
        />
      </div>
      <div className="grid gap-4 p-4 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2">
        <div className="bg-white shadow rounded-lg p-4">
          <BenefitsChart branches={branches} />
        </div>
        <div className="bg-white shadow rounded-lg p-4">
          <BenefitsDaysChart branches={branches} />
        </div>
      </div>
    </>
  );
};

export default BenefitsComponent;
